var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleads(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7091 28C11.7091 26.2217 12.0107 24.5168 12.5491 22.9177L3.12582 15.8716C1.28927 19.5228 0.254547 23.637 0.254547 28C0.254547 32.3593 1.288 36.4709 3.122 40.1196L12.5402 33.0599C12.0069 31.4683 11.7091 29.7696 11.7091 28Z",
    fill: "#9CA3AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2546 11.8222C32.2 11.8222 35.7636 13.1911 38.5636 15.4311L46.7091 7.46667C41.7455 3.23556 35.3818 0.622223 28.2546 0.622223C17.1895 0.622223 7.67964 6.81831 3.12582 15.8716L12.5491 22.9177C14.7204 16.464 20.9096 11.8222 28.2546 11.8222Z",
    fill: "#B3BAC5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2546 44.1778C20.9096 44.1778 14.7204 39.536 12.5491 33.0823L3.12582 40.1271C7.67964 49.1817 17.1895 55.3778 28.2546 55.3778C35.084 55.3778 41.6042 53.0034 46.4978 48.5545L37.5531 41.7835C35.0293 43.3403 31.8513 44.1778 28.2546 44.1778Z",
    fill: "#B3BAC5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9818 28C54.9818 26.3822 54.7273 24.64 54.3455 23.0222H28.2545V33.6H43.2727C42.5218 37.2064 40.4778 39.979 37.5531 41.7835L46.4978 48.5545C51.6384 43.8828 54.9818 36.9239 54.9818 28Z",
    fill: "#9CA3AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleads);
export default __webpack_public_path__ + "static/media/googleads.de880c197ffc9b90f449c385c9966d7d.svg";
export { ForwardRef as ReactComponent };